function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "img-change_module_svg__a",
  d: "M0 .793h97.203V68H0z"
}), React.createElement("path", {
  id: "img-change_module_svg__c",
  d: "M10.816.544a.702.702 0 0 0 0 .991l1.608 1.608H4.303A3.505 3.505 0 0 0 .797 6.647v1.402a.701.701 0 0 0 1.402 0V6.647c0-1.161.942-2.102 2.104-2.102h8.121l-1.608 1.606a.7.7 0 1 0 .991.992l2.804-2.804a.698.698 0 0 0 0-.991L11.807.544a.7.7 0 0 0-.991 0zm2.599 8.907v1.402a2.102 2.102 0 0 1-2.103 2.103H3.191l1.607-1.607a.7.7 0 1 0-.991-.992l-2.804 2.804a.701.701 0 0 0 0 .992l2.804 2.804a.701.701 0 0 0 .991-.992l-1.607-1.607h8.121a3.506 3.506 0 0 0 3.506-3.505V9.451a.701.701 0 1 0-1.403 0z"
}), React.createElement("path", {
  id: "img-change_module_svg__e",
  d: "M10.816.544a.702.702 0 0 0 0 .991l1.608 1.608H4.303A3.505 3.505 0 0 0 .797 6.647v1.402a.701.701 0 0 0 1.402 0V6.647c0-1.161.942-2.102 2.104-2.102h8.121l-1.608 1.606a.7.7 0 1 0 .991.992l2.804-2.804a.698.698 0 0 0 0-.991L11.807.544a.703.703 0 0 0-.991 0zm2.599 8.907v1.402a2.102 2.102 0 0 1-2.103 2.103H3.191l1.607-1.607a.7.7 0 1 0-.991-.992l-2.804 2.804a.699.699 0 0 0 0 .992l2.804 2.804a.698.698 0 0 0 .991 0 .701.701 0 0 0 0-.992l-1.607-1.607h8.121a3.506 3.506 0 0 0 3.506-3.505V9.451a.701.701 0 1 0-1.403 0z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: 84,
  cy: 79,
  r: 61,
  fill: "#F2F3F7"
}), React.createElement("g", {
  transform: "translate(10 61.182)"
}, React.createElement("mask", {
  id: "img-change_module_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#img-change_module_svg__a"
})), React.createElement("path", {
  fill: "#E9EAF0",
  d: "M96.71 12.353a4.91 4.91 0 0 1-1.438 3.382L58.368 52.638a4.928 4.928 0 0 1-6.97 0L1.96 3.201A4.898 4.898 0 0 1 .66.873L0 .793v14.203l51.5 51.5a5.134 5.134 0 0 0 7.26 0l38.443-38.442V12.412l-.493-.059z",
  mask: "url(#img-change_module_svg__b)"
})), React.createElement("path", {
  stroke: "#C0C2CC",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.508,
  d: "M11.059 70.495l50.394 50.394a5.025 5.025 0 0 0 7.103 0l27.907-27.905"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M80.617 47.049L62.401 28.833l-21.56 2.047-27.699 27.697a4.821 4.821 0 0 0 0 6.817l48.353 48.353a4.82 4.82 0 0 0 6.817 0l36.093-36.093a4.82 4.82 0 0 0 0-6.817L97.368 63.8"
}), React.createElement("path", {
  fill: "#E9EAF0",
  d: "M40.508 31.411l7.649 7.649a3.095 3.095 0 0 0 4.376 0l9.617-9.617"
}), React.createElement("path", {
  fill: "#C0C2CC",
  d: "M89.355 93.842a.84.84 0 0 1-.133.173l-20.32 20.321a5.612 5.612 0 0 1-3.998 1.655 5.613 5.613 0 0 1-3.998-1.655L12.553 65.983a5.617 5.617 0 0 1-1.656-3.998 5.61 5.61 0 0 1 1.655-3.997l27.7-27.698a.827.827 0 0 1 .508-.24l21.562-2.046a.834.834 0 0 1 .668.24l27.353 27.353a.832.832 0 1 1-1.177 1.179L62.088 29.7l-20.872 1.98-27.485 27.486a3.961 3.961 0 0 0-1.168 2.82 3.96 3.96 0 0 0 1.168 2.818l48.353 48.353a3.96 3.96 0 0 0 2.82 1.168 3.96 3.96 0 0 0 2.818-1.168l20.321-20.32a.833.833 0 0 1 1.312 1.005"
}), React.createElement("path", {
  fill: "#C0C2CC",
  d: "M62.692 33.407a.812.812 0 0 1-.134.173l-9.538 9.538a3.882 3.882 0 0 1-2.76 1.144 3.877 3.877 0 0 1-2.758-1.143l-7.587-7.587a.832.832 0 1 1 1.177-1.179l7.587 7.588c.423.422.985.654 1.581.654.598 0 1.16-.232 1.581-.655l9.54-9.538a.833.833 0 0 1 1.311 1.005M73.526 52.32a.807.807 0 0 1-.133.172l-30.38 30.38a.833.833 0 0 1-1.177-1.179l30.378-30.379a.834.834 0 0 1 1.312 1.005m5.434 5.434a.812.812 0 0 1-.133.173l-30.38 30.38a.834.834 0 0 1-1.177-1.179l30.379-30.379a.832.832 0 0 1 1.178 0 .83.83 0 0 1 .134 1.005m5.433 5.433a.807.807 0 0 1-.133.173l-30.38 30.38a.834.834 0 0 1-1.178-1.178l30.38-30.38a.833.833 0 0 1 1.311 1.005m-7.413 18.281a.812.812 0 0 1-.134.173l-17.47 17.473a.834.834 0 0 1-1.179-1.179L75.67 80.462a.832.832 0 0 1 1.178 0 .831.831 0 0 1 .134 1.005m5.433 5.434a.812.812 0 0 1-.134.173l-17.756 17.757a.834.834 0 0 1-1.178-1.179l17.756-17.756a.832.832 0 0 1 1.178 0 .83.83 0 0 1 .134 1.005M37.602 75.515a.832.832 0 0 1-1.312.173L25.785 65.184a3.907 3.907 0 0 1 0-5.518L37.573 47.88a.832.832 0 1 1 1.177 1.178L26.964 60.844a2.24 2.24 0 0 0 0 3.162L37.468 74.51a.831.831 0 0 1 .134 1.005"
}), React.createElement("path", {
  fill: "#FF4056",
  d: "M113.037 75.759c0 7.859-6.371 14.23-14.229 14.23-7.86 0-14.231-6.371-14.231-14.23 0-7.86 6.371-14.23 14.231-14.23 7.858 0 14.229 6.37 14.229 14.23m8.925 9.685a.817.817 0 0 1-.217.028h-6.44a.833.833 0 0 1 0-1.666l6.44-.001a.835.835 0 0 1 .217 1.639m-3.899 10.591a.836.836 0 0 1-.806-.216l-4.554-4.554a.834.834 0 0 1 1.178-1.178l4.555 4.554a.835.835 0 0 1-.373 1.394m-10.591 3.898a.835.835 0 0 1-1.05-.805v-6.44a.833.833 0 1 1 1.667 0v6.44c0 .386-.262.71-.617.805"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M94.19 81.54l1.607 1.607a.7.7 0 1 1-.991.992l-2.804-2.804a.703.703 0 0 1 0-.992l2.804-2.803a.7.7 0 1 1 .991.99l-1.607 1.608h8.122a2.103 2.103 0 0 0 2.103-2.103v-1.402a.7.7 0 1 1 1.402 0v1.402a3.505 3.505 0 0 1-3.505 3.505H94.19zm9.233-9.813h-8.12a2.102 2.102 0 0 0-2.104 2.103v1.4a.7.7 0 1 1-1.402 0v-1.4a3.505 3.505 0 0 1 3.505-3.505h8.121l-1.607-1.608a.702.702 0 0 1 .991-.991l2.804 2.804a.7.7 0 0 1 0 .99l-2.804 2.805a.7.7 0 1 1-.99-.992l1.606-1.606z"
}), React.createElement("g", {
  transform: "translate(91 67.182)"
}, React.createElement("mask", {
  id: "img-change_module_svg__d",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#img-change_module_svg__c"
})), React.createElement("path", {
  fill: "#FFF",
  d: "M.798 17.162h14.02V.338H.798z",
  mask: "url(#img-change_module_svg__d)"
})), React.createElement("g", {
  transform: "translate(91 67.182)"
}, React.createElement("mask", {
  id: "img-change_module_svg__f",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#img-change_module_svg__e"
})), React.createElement("path", {
  fill: "#FFF",
  d: "M-2.707 20.667h21.029V-3.166H-2.707z",
  mask: "url(#img-change_module_svg__f)"
})));

var SvgImgChangeModule = function SvgImgChangeModule(props) {
  return React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150"
  }, props), _ref, _ref2);
};

export default SvgImgChangeModule;